export default __webpack_public_path__ + "static/media/location.1c191b3d.png";